import { getFreezeCap } from './streakService';

/**
 * Coin Service
 * Handles workout rewards and freeze purchases.
 */

export const awardWorkoutCoins = (user, today) => {
  const lastRewardDate = user.last_coin_reward_date || user.lastCoinRewardDate;
  const successfulGamesCount = user.successfulGamesCount || 0;

  // Rule: +25 coins for completing Daily Workout (3 successful games)
  // Only once per calendar day.
  if (successfulGamesCount >= 3 && lastRewardDate !== today) {
    return 25;
  }
  return 0;
};

export const canBuyFreeze = (user) => {
  const coins = Number(user.coins || 0);
  const currentFreezes = Number(user.streak_freezes ?? user.streakFreezes ?? 0) || 0;
  const cap = getFreezeCap();

  return coins >= 100 && currentFreezes < cap;
};

export const buyFreeze = (user) => {
  if (!canBuyFreeze(user)) return null;
  
  const currentFreezes = Number(user.streak_freezes ?? user.streakFreezes ?? 0) || 0;
  
  return {
    coins: (Number(user.coins) || 0) - 100,
    streak_freezes: currentFreezes + 1
  };
};

export const calculateRestoreCost = (missedDays) => {
  if (missedDays <= 0) return 0;
  return missedDays * 100;
};

export const canRestoreStreak = (user, missedDays) => {
  if (missedDays <= 0 || missedDays > 3) return false;
  const cost = calculateRestoreCost(missedDays);
  return (user.coins || 0) >= cost;
};

export const restoreStreak = (user, missedDays, previousStreak) => {
  if (!canRestoreStreak(user, missedDays)) return null;
  
  const cost = calculateRestoreCost(missedDays);
  
  return {
    coins: (user.coins || 0) - cost,
    streak: previousStreak
  };
};
